export default __webpack_public_path__ + "static/media/download-android-fr.1980b092.png";